import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import useAuth from '../hooks/useAuth';

const IcoCard     = ({className="w-5 h-5"}) => (<svg viewBox="0 0 24 24" fill="currentColor" className={className}><path d="M20 4H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/></svg>);
const IcoCheck    = ({className="w-5 h-5"}) => (<svg viewBox="0 0 24 24" fill="currentColor" className={className}><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>);
const IcoClock    = ({className="w-5 h-5"}) => (<svg viewBox="0 0 24 24" fill="currentColor" className={className}><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm.5 5v5.25l4.5 2.67-.75 1.23L11 13V7h1.5z"/></svg>);
const IcoBlock    = ({className="w-5 h-5"}) => (<svg viewBox="0 0 24 24" fill="currentColor" className={className}><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69l11.21-11.21C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z"/></svg>);
const IcoUsers    = ({className="w-5 h-5"}) => (<svg viewBox="0 0 24 24" fill="currentColor" className={className}><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>);
const IcoCalendar = ({className="w-5 h-5"}) => (<svg viewBox="0 0 24 24" fill="currentColor" className={className}><path d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"/></svg>);
const IcoUser     = ({className="w-5 h-5"}) => (<svg viewBox="0 0 24 24" fill="currentColor" className={className}><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>);
const IcoGlobe    = ({className="w-5 h-5"}) => (<svg viewBox="0 0 24 24" fill="currentColor" className={className}><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/></svg>);
const IcoEye      = ({className="w-5 h-5"}) => (<svg viewBox="0 0 24 24" fill="currentColor" className={className}><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/></svg>);

const estadoBadge = (estado) => {
    const map = {
        activa:      { label: 'Activa',      cls: 'bg-green-100 text-green-700' },
        sin_activar: { label: 'Sin activar', cls: 'bg-amber-100 text-amber-700' },
        bloqueada:   { label: 'Bloqueada',   cls: 'bg-red-100 text-red-700' },
    };
    const e = map[estado] || { label: estado, cls: 'bg-gray-100 text-gray-500' };
    return <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${e.cls}`}>{e.label}</span>;
};

const accionLabel = (accion) => {
    const map = {
        LOGIN:             { label: 'Inicio de sesión', color: '#0057B7' },
        LOGIN_FALLIDO:     { label: 'Login fallido',    color: '#EF4444' },
        UPDATE_PERFIL_NFC: { label: 'Perfil editado',   color: '#8B5CF6' },
        CREATE_TARJETA:    { label: 'Tarjeta creada',   color: '#00A651' },
        ASIGNAR_TARJETA:   { label: 'Tarjeta asignada', color: '#F97316' },
        CREATE_USER:       { label: 'Usuario creado',   color: '#06B6D4' },
        UPDATE_USER:       { label: 'Usuario editado',  color: '#6366F1' },
        UPDATE_SETTING:    { label: 'Config. editada',  color: '#F59E0B' },
    };
    return map[accion] || { label: accion, color: '#9CA3AF' };
};

const StatCard = ({ label, value, icon, color, bg }) => (
    <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100 flex items-center gap-3">
        <div className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: bg }}>
            <span style={{ color }}>{icon}</span>
        </div>
        <div>
            <p className="text-xl font-bold text-gray-800 leading-none">{value ?? '—'}</p>
            <p className="text-xs text-gray-400 mt-0.5">{label}</p>
        </div>
    </div>
);

const Dashboard = () => {
    const [data,    setData]    = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { user } = useAuth();

    useEffect(() => {
        api.get('/dashboard')
            .then(({ data }) => setData(data))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    if (loading) return (
        <div className="flex items-center justify-center h-64">
            <div className="w-7 h-7 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
        </div>
    );

    if (!data) return (
        <div className="flex items-center justify-center h-64 text-gray-400 text-sm">
            No se pudo cargar el dashboard.
        </div>
    );

    // ── Vista Cliente ────────────────────────────────────────────────
    if (data.role === 'cliente') {
        const activas       = data.tarjetas.filter(t => t.estado === 'activa').length;
        const totalVisitas  = data.tarjetas.reduce((sum, t) => sum + (parseInt(t.total_visitas) || 0), 0);

        return (
            <div className="space-y-5 max-w-lg mx-auto">

                {/* Hero saludo */}
                <div className="rounded-3xl overflow-hidden shadow-md"
                     style={{ background: 'linear-gradient(135deg, var(--color-primary) 0%, #0080ff 100%)' }}>
                    <div className="px-5 pt-6 pb-4 flex flex-col items-center text-center">
                        <p className="text-white/60 text-xs font-semibold uppercase tracking-widest mb-4">Bienvenido 👋</p>
                        <div className="w-20 h-20 rounded-full overflow-hidden shadow-lg mb-3 flex-shrink-0"
                             style={{ border: '3px solid rgba(255,255,255,0.7)' }}>
                            {user?.foto_url ? (
                                <img src={user.foto_url} alt="Foto" className="w-full h-full object-cover" />
                            ) : (
                                <div className="w-full h-full flex items-center justify-center text-2xl font-bold text-white bg-white/20">
                                    {user?.nombre?.charAt(0)}
                                </div>
                            )}
                        </div>
                        <h1 className="text-white text-lg font-bold">{user?.nombre} {user?.apellido}</h1>
                        <p className="text-white/50 text-xs mt-1 px-4" style={{ overflowWrap: 'break-word', wordBreak: 'break-all' }}>
                            {user?.email}
                        </p>
                    </div>
                    <div className="grid grid-cols-3 border-t border-white/10">
                        <div className="flex flex-col items-center py-3 border-r border-white/10">
                            <p className="text-white text-xl font-bold">{data.tarjetas.length}</p>
                            <p className="text-white/60 text-xs">Tarjeta{data.tarjetas.length !== 1 ? 's' : ''}</p>
                        </div>
                        <div className="flex flex-col items-center py-3 border-r border-white/10">
                            <p className="text-white text-xl font-bold">{activas}</p>
                            <p className="text-white/60 text-xs">Activa{activas !== 1 ? 's' : ''}</p>
                        </div>
                        <div className="flex flex-col items-center py-3">
                            <p className="text-white text-xl font-bold">{totalVisitas}</p>
                            <p className="text-white/60 text-xs">Visitas</p>
                        </div>
                    </div>
                </div>

                {/* Tarjetas */}
                <div>
                    <h2 className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-3 px-1">Mis tarjetas digitales</h2>
                    {data.tarjetas.length === 0 ? (
                        <div className="flex flex-col items-center justify-center h-32 gap-2 bg-white rounded-2xl border border-gray-100 shadow-sm">
                            <IcoCard className="w-8 h-8 text-gray-200" />
                            <p className="text-gray-400 text-sm">No tienes tarjetas asignadas.</p>
                        </div>
                    ) : (
                        <div className="space-y-3">
                            {data.tarjetas.map(t => (
                                <div key={t.uuid} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                                    <div className="flex items-center gap-3 p-4">
                                        <div className="w-12 h-12 rounded-xl overflow-hidden bg-gray-100 flex-shrink-0">
                                            {t.foto_url ? (
                                                <img src={t.foto_url} alt="Foto" className="w-full h-full object-cover" />
                                            ) : (
                                                <div className="w-full h-full flex items-center justify-center text-gray-300">
                                                    <IcoUser className="w-6 h-6" />
                                                </div>
                                            )}
                                        </div>
                                        <div className="flex-1 min-w-0">
                                            <p className="font-bold text-gray-800 text-sm truncate">
                                                {t.nombre ? `${t.nombre} ${t.apellido}`.trim() : 'Sin configurar'}
                                            </p>
                                            <p className="text-xs text-gray-400 truncate">{t.cargo || 'Sin cargo'}</p>
                                            <div className="flex items-center gap-2 mt-1 flex-wrap">
                                                {estadoBadge(t.estado)}
                                                <span className="text-xs text-gray-300 font-mono">{t.codigo}</span>
                                                <span className="flex items-center gap-0.5 text-xs text-gray-400">
                                                    <IcoEye className="w-3 h-3" /> {t.total_visitas || 0}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-2 border-t border-gray-50">
                                        <button onClick={() => navigate(`/mis-tarjetas/${t.uuid}`)}
                                            className="py-3 text-xs font-bold text-white hover:opacity-90 transition-all"
                                            style={{ backgroundColor: 'var(--color-primary)' }}>
                                            ✏️ Editar perfil
                                        </button>
                                        <a href={`/c/${t.codigo}`} target="_blank" rel="noreferrer"
                                            className="py-3 text-xs font-bold text-center text-gray-500 hover:bg-gray-50 transition-all border-l border-gray-50">
                                            🌐 Ver público
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Acciones rápidas */}
                <div>
                    <h2 className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-3 px-1">Acciones rápidas</h2>
                    <div className="grid grid-cols-3 gap-3">
                        {[
                            { icon: <IcoCard className="w-6 h-6" />,  label: 'Mis tarjetas', action: () => navigate('/mis-tarjetas'), color: '#0057B7', bg: '#EFF6FF' },
                            { icon: <IcoUser className="w-6 h-6" />,  label: 'Mi perfil',    action: () => navigate('/profile'),     color: '#7C3AED', bg: '#F5F3FF' },
                            { icon: <IcoGlobe className="w-6 h-6" />, label: 'Ver perfil',   action: () => data.tarjetas[0] && window.open(`/c/${data.tarjetas[0].codigo}`, '_blank'), color: '#059669', bg: '#ECFDF5' },
                        ].map((item, i) => (
                            <button key={i} onClick={item.action}
                                className="bg-white rounded-2xl border border-gray-100 p-4 flex flex-col items-center gap-2 hover:shadow-md hover:scale-105 transition-all active:scale-95 shadow-sm">
                                <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: item.bg }}>
                                    <span style={{ color: item.color }}>{item.icon}</span>
                                </div>
                                <span className="text-xs text-gray-600 font-semibold leading-tight text-center">{item.label}</span>
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    // ── Vista Admin / Gerente ────────────────────────────────────────
    const m = data.metrics;
    return (
        <div className="space-y-5">
            <div className="flex items-center justify-between">
                <div>
                    <h1 className="text-xl font-bold text-gray-800">Dashboard</h1>
                    <p className="text-gray-400 text-sm mt-0.5">
                        {new Date().toLocaleDateString('es-CO', { weekday: 'long', day: 'numeric', month: 'long' })}
                    </p>
                </div>
                <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-blue-50">
                    <span className="text-blue-600"><IcoCalendar /></span>
                </div>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
                <StatCard label="Total tarjetas"  value={m.total_tarjetas} icon={<IcoCard />}     color="#0057B7" bg="#EFF6FF" />
                <StatCard label="Activas"          value={m.activas}        icon={<IcoCheck />}    color="#059669" bg="#ECFDF5" />
                <StatCard label="Sin activar"      value={m.sin_activar}    icon={<IcoClock />}    color="#D97706" bg="#FFFBEB" />
                <StatCard label="Bloqueadas"       value={m.bloqueadas}     icon={<IcoBlock />}    color="#DC2626" bg="#FEF2F2" />
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
                <StatCard label="Clientes"         value={m.total_clientes}  icon={<IcoUsers />}    color="#7C3AED" bg="#F5F3FF" />
                <StatCard label="Usuarios totales" value={m.total_usuarios}  icon={<IcoUser />}     color="#0891B2" bg="#ECFEFF" />
                <StatCard label="Nuevas este mes"  value={m.tarjetas_mes}    icon={<IcoCalendar />} color="#EA580C" bg="#FFF7ED" />
                <StatCard label="Total visitas"    value={m.total_visitas||0}icon={<IcoEye />}      color="#0891B2" bg="#ECFEFF" />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                    <div className="px-5 py-4 border-b border-gray-50 flex items-center gap-2">
                        <div className="w-7 h-7 rounded-lg bg-blue-50 flex items-center justify-center">
                            <span className="text-blue-600"><IcoCard className="w-4 h-4" /></span>
                        </div>
                        <h3 className="text-sm font-bold text-gray-700">Últimas tarjetas</h3>
                    </div>
                    <div className="divide-y divide-gray-50">
                        {data.ultimas_tarjetas.map((t, i) => (
                            <div key={i} className="flex items-center px-5 py-3 hover:bg-gray-50 transition">
                                <div className="flex-1 min-w-0">
                                    <p className="text-sm font-semibold text-gray-700 font-mono truncate">{t.codigo}</p>
                                    <p className="text-xs text-gray-400 truncate">
                                        {t.nombre ? `${t.nombre} ${t.apellido}` : 'Sin asignar'}
                                    </p>
                                </div>
                                <div className="flex-shrink-0 ml-3 text-right">
                                    {estadoBadge(t.estado)}
                                    <p className="text-xs text-gray-400 mt-1 flex items-center justify-end gap-0.5">
                                        <IcoEye className="w-3 h-3" /> {t.total_visitas || 0} visitas
                                    </p>
                                </div>
                            </div>
                        ))}
                        {data.ultimas_tarjetas.length === 0 && (
                            <div className="px-5 py-8 text-center text-gray-300 text-sm">Sin tarjetas aún</div>
                        )}
                    </div>
                </div>

                <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                    <div className="px-5 py-4 border-b border-gray-50 flex items-center gap-2">
                        <div className="w-7 h-7 rounded-lg bg-purple-50 flex items-center justify-center">
                            <span className="text-purple-600"><IcoClock className="w-4 h-4" /></span>
                        </div>
                        <h3 className="text-sm font-bold text-gray-700">Actividad reciente</h3>
                    </div>
                    <div className="divide-y divide-gray-50">
                        {data.actividad.map((a, i) => {
                            const info = accionLabel(a.accion);
                            return (
                                <div key={i} className="flex items-center gap-3 px-5 py-3 hover:bg-gray-50 transition">
                                    <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: info.color }} />
                                    <div className="flex-1 min-w-0">
                                        <p className="text-sm font-medium text-gray-700 truncate">{info.label}</p>
                                        <p className="text-xs text-gray-400 truncate">
                                            {a.nombre ? `${a.nombre} ${a.apellido}` : 'Sistema'}
                                        </p>
                                    </div>
                                    <p className="text-xs text-gray-400 flex-shrink-0 font-mono">
                                        {new Date(a.creado_en).toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' })}
                                    </p>
                                </div>
                            );
                        })}
                        {data.actividad.length === 0 && (
                            <div className="px-5 py-8 text-center text-gray-300 text-sm">Sin actividad reciente</div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
